// @flow
import React, { type Node } from 'react';
import LetterComment from 'components/letter/LetterComment';
import type { Comment, SubCommentsMap } from 'store/modules/letters';
import { Link } from 'react-router-dom';
import { numberWithCommas } from 'lib/common';

import './LetterComments.scss';

type Props = {
  commentInput: Node,
  commentsCount: number,
  comments: ?(Comment[]),
  onReply: (text: string, replyTo: ?string, parentId?: ?string) => Promise<*>,
  onReadReplies: (commentId: string, parentId?: ?string) => Promise<*>,
  subCommentsMap: SubCommentsMap,
  logged: boolean,
  username: ?string,
  onOpenRemove: (payload: { commentId: string, parentId: ?string }) => any,
  onEditComment: ({
    commentId: string,
    parentId: ?string,
    text: string,
  }) => any,
  currentPath: string,
};

const LetterComments = ({
  commentInput,
  comments,
  onReply,
  onReadReplies,
  subCommentsMap,
  logged,
  username,
  onOpenRemove,
  onEditComment,
  commentsCount,
  currentPath,
}: Props) => (
  <div className="LetterComments">
    <h3 className="title">
      댓글 <span className="count">{numberWithCommas(commentsCount)}</span>
    </h3>
    <div className="comment-input">{commentInput}</div>
    {!logged && (
      <div className="ask-login">
        <Link to={`/login?next=${currentPath}`}>로그인</Link> 후 댓글을 등록 할 수 있습니다.
      </div>
    )}
    <div className="comment-list">
      {comments &&
        comments.map(comment => {
          return (
            <LetterComment
              key={comment.id}
              id={comment.id}
              username={comment.user.username}
              thumbnail={comment.user.thumbnail}
              date={comment.created_at}
              comment={comment.text}
              replies={subCommentsMap[comment.id]}
              repliesCount={comment.replies_count}
              subCommentsMap={subCommentsMap}
              onReadReplies={onReadReplies}
              onReply={onReply}
              logged={logged}
              currentUsername={username}
              onOpenRemove={onOpenRemove}
              onEditComment={onEditComment}
            />
          );
        })}
    </div>
  </div>
);

export default LetterComments;



// WEBPACK FOOTER //
// ./src/components/letter/LetterComments/LetterComments.js